import React, { useState, useEffect, useRef } from 'react';
import Reading from './subPages/reading';
import UserInfo from './subPages/userInfo';
import ResultPage from './subPages/result';
import CompetencyResult from './subPages/competencyResult';
import Personality from './subPages/personality';
import VoicePage from './subPages/voice';
import NewVoicePage from './subPages/newVoice';
import InterviewRecord from './subPages/interviewRecord';
import SharePage from './subPages/share';
import LimbDetection from './subPages/limbdetection';
import MentalHealth from './subPages/mentalHealth';
import Placeholder from './common/placeholder';
import { ajax, unparam } from 'utils/common';
import './index.less';

import reportBgTop from '../../images/aiReport/report-bg-top.jpg';
import reportBgBottom from '../../images/aiReport/report-bg-bottom.jpg';
import logo from '../../images/aiReport/ai-logo.png';

const ReportApp = () => {
    const queryString = unparam(window.location.search);
    const closeVideoRef = useRef(null);
    const closeAudioRef = useRef(null);
    const shareRef = useRef(null);
    const [data, setData] = useState({});
    const [isLoad, setIsLoad] = useState(true);
    const [isValid, setIsValid] = useState(true);   // 报告是否有效

    useEffect(() => {
        document.title = 'AI面试分析报告';
        ajax({
            url: "/rept/interview/report",
            data: {
                ...queryString,
            }
        }).then(res => {
            let result = res.data || {};
            // result.interviewResult.radarDataList = result.interviewResult.radarDataList.splice(0, 2)
            setData(result);
            setIsLoad(result.status != 10002)
        }).catch(err => {
            // 处理无权限
            if(err.response.status === 403){
                setIsValid(false);
            }
        })
    }, [])
    // 关闭video
    const closeVideo = () => {
        closeVideoRef.current && closeVideoRef.current.closeVideo();
    };
    // 关闭audio
    const closeAudio = () => {
        closeAudioRef.current && closeAudioRef.current.closeAudio();
    };

    const onBodyClick = (event) => {
        shareRef.current && shareRef.current.closePopover();
    };

    return (
        <div className="analysisNewWrap">
            <div className="analysisNew" onClick={onBodyClick}>
                <img src={reportBgTop} className="reportBgTop" />
                {isLoad && <img src={reportBgBottom} className="reportBgBottom" />}
                {/*头部logo 标题*/}
                <div className="logo-wrap">
                    <img src={logo} className="logo" />
                    <span>AI面试分析报告</span>
                </div>
                <div className="analysisContent" style={isLoad ? {} : { paddingBottom: 50 }}>
                    {
                        isValid ?
                        <React.Fragment>
                            {/*用户结果*/}
                            <UserInfo data={data.userInfo || {}} totalDetail={data.interviewResult || {}} hasAiAbility={data.hasAiAbility || false} isLoad={isLoad} />
                            {/*分析结果*/}
                            {isLoad && <ResultPage data={data.interviewResult || {}} userInfo={data.userInfo || {}} hasAiAbility={data.hasAiAbility || false}/>}
                            {/*胜任力分析*/}
                            {isLoad && data.abilityAnalysisReport && <CompetencyResult data={data.abilityAnalysisReport || {}} />}
                            {/* 大五人格 Personality */}
                            {isLoad && data.bigFivePersonalityReport && <Personality data={data.bigFivePersonalityReport || {}} />}
                            {/*语音分析*/}
                            {isLoad && !data.useAiVoiceResult && <VoicePage data={data.voiceAnalysisReport || {}} closeVideo={closeVideo} ref={closeAudioRef} />}
                            {isLoad && data.useAiVoiceResult &&
                                <NewVoicePage data={data || {}} closeVideo={closeVideo} ref={closeAudioRef} />}
                            {/* 手部综合检测 */}
                            {isLoad && <LimbDetection ref={closeVideoRef} closeAudio={closeAudio} 
                                data={data.gestureDetectionResult ? 
                                    {
                                        ...data.gestureDetectionResult,
                                        facePicPath: data.interviewResult && data.interviewResult.facePicPath || '',
                                        lastView: data.readingGuide ? false : true,
                                    }
                                    : {}} 
                                userInfo={data.userInfo || {}}/>}
                            {/* 心里健康 mentalHealth*/}
                            {isLoad && data.psyphologyReport && <MentalHealth data={data.psyphologyReport || {}} userInfo={data.userInfo || {}}/>}
                            {/*面试记录*/}
                            <InterviewRecord ref={closeVideoRef} closeAudio={closeAudio} data={data.interviewResult || {}} userInfo={data.userInfo || {}}/>
                            {/*阅读指南*/}
                            {isLoad && data.readingGuide && <Reading data={data.readingGuide || {}} />}

                        </React.Fragment> :
                        <Placeholder />
                    }
                </div>
            </div>
            {/*分享*/}
            {isValid && <SharePage ref={shareRef}/>}
        </div>
    )
};

export default ReportApp;
